module.exports = __webpack_public_path__ + "static/media/ic_ac_open.8b5dacfe.png";